// NOTICE: KAPTION-INTEGRATION
import AssignableAssistantsAPI from '../../api/assignableAssistants';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const types = {
  SET_KAPTION_ASSISTANTS_UI_FLAG: 'SET_KAPTION_ASSISTANTS_UI_FLAG',
  SET_KAPTION_ASSISTANTS: 'SET_KAPTION_ASSISTANTS',
};

export const getters = {
  getAssistants($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.SET_KAPTION_ASSISTANTS_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload },
      } = await AssignableAssistantsAPI.get([]);
      commit(types.SET_KAPTION_ASSISTANTS, payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_KAPTION_ASSISTANTS_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_KAPTION_ASSISTANTS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_KAPTION_ASSISTANTS]($state, data) {
    $state.records = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
